import React, { useMemo } from 'react';
import { COUNTRIES } from 'config/data/countries';
import SelectField from '../Select.Formik';
import { FlagEmoji } from 'react-international-phone';

interface CountrySelectFieldProps {
  showFlag?: boolean;
  compact?: boolean;
  name?: string;
  label?: string;
  abbreviateRequired?: boolean;
  disabled?: boolean;
  showRequiredFields?: boolean;
  style?: React.CSSProperties;
}

interface CountryOption {
  label: string;
  value: string;
  optionLabel?: string;
}

/**
 * Formik enabled country dropdown
 *
 * If both `compact` and `showFlag`, items display as "🇺🇸 US" instead of "United States"
 */

export const CountrySelectField: React.FC<CountrySelectFieldProps> = ({
  showFlag,
  name = 'country',
  label = 'Country',
  compact,
  style,
  ...selectFieldProps
}) => {
  return (
    <SelectField
      name={name}
      data-testid={name}
      label={label}
      options={COUNTRIES}
      formatOptionLabel={useMemo(() => {
        if (showFlag) {
          return (option: CountryOption) => (
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <FlagEmoji
                iso2={option.value.toLocaleLowerCase()}
                size={'24px'}
                style={{ marginRight: '8px' }}
              />
              {compact ? option.value : option.label}
            </div>
          );
        }
      }, [compact, showFlag])}
      style={style}
      {...selectFieldProps}
    />
  );
};

export default CountrySelectField;
